import React from 'react';
import TenantPaymentReview from '../../../components/TenantPaymentReview';
import TenantPayments from '../../../components/TenantPayments';
import { useTour } from '../../../core/TourProvider';
import { PaymentsSubsceneId } from '../../../core/PaymentsEnums';
import TenantLayout from '../../../mimic/tenant/TenantLayout';

const TenantPayScene = () => {
  const { next, setSubscene, currentSubscene } = useTour();
  const activeSubsceneId = currentSubscene?.id ?? PaymentsSubsceneId.LIST;
  const isReviewFlow =
    activeSubsceneId === PaymentsSubsceneId.REVIEW ||
    activeSubsceneId === PaymentsSubsceneId.PROCESSING ||
    activeSubsceneId === PaymentsSubsceneId.SUCCESS;

  const handleMakePayment = () => {
    setSubscene(PaymentsSubsceneId.REVIEW);
  };

  return (
    <TenantLayout>
      {!isReviewFlow ? (
        <TenantPayments onMakePayment={handleMakePayment} />
      ) : (
        <TenantPaymentReview onSubmit={next} />
      )}
    </TenantLayout>
  );
};

export default TenantPayScene;
